import { render, staticRenderFns } from "./PaPills.vue?vue&type=template&id=e8604c7a"
import script from "./PaPills.vue?vue&type=script&lang=js"
export * from "./PaPills.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports